import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { UserData } from '../../../providers/user-data';
import { DonationData } from '../../../providers/donation-data';
import { AppSettings } from '../../../config/app-settings';
import { Helpers } from '../../../providers/helpers';

@Component({
	selector: 'page-modal-donate-submit',
	templateUrl: 'modal-donate-submit.html'
})

export class ModalDonateSubmit {
	public formData: any;
	public currentUser: any;
	public loading: any;
	public message: string;
	public submitted: boolean = false;
	@ViewChild('postContentInput') postInput: any;

	constructor(
		public nav: NavController,
		public platform: Platform,
    	public params: NavParams,
    	public viewCtrl: ViewController,
    	private userData: UserData,
    	private donationData: DonationData,
    	private events: Events,
    	private settings: AppSettings,
    	private helpers: Helpers
    ) {	
    	this.initData();
    }

	ngAfterViewInit() {
		this.postInput.setFocus();		
	}

	public dismiss() {
		this.viewCtrl.dismiss();
	}

	public initData(){
		this.currentUser = this.params.get("user");
		this.formData = {
			donorName: this.currentUser? this.currentUser.displayName: "",
			donorPic: this.currentUser? this.currentUser.photoURL: "",
			uid: this.currentUser? this.currentUser.uid : 0,
			amount: ''
		};
	}
  
  	public submitDonation(){
  		var self = this;
  		
  		if(self.formData.amount != "" && self.formData.amount > 0){
  			self.showLoading();
			self.donationData.addDonation(self.currentUser.uid, self.formData).subscribe(newDonation =>{
				if(newDonation){
					self.submitted = true;
				}	
				self.hideLoading();		
			});
	    }else{
	    	self.message = "*Please input the amount you want to donate";
	    }
  	}

  	public returnCount() {
	    if(this.formData){
	      return this.settings.feedPostMaxChar - this.formData.text.length;
	    }
  	}

  	public getMaxChar(){
  		return this.settings.feedPostMaxChar;
  	}

  	public showLoading(){
        this.loading = this.helpers.showMessage("Processing your donation...");
    }

    public hideLoading(){
        this.helpers.hideLoading();
    }
}



// WEBPACK FOOTER //
// ./src/pages/giving/components/modal-donate-submit.ts